import { User } from '../../../../common/models/user-interface';
import { EntityState } from '../../store/store.utils';
import { History } from '../../../../common/models/history.interface';

export interface FilterModel {
    field: string;
    operator: string;
    value: string;
}

export const initialHistoryState: HistoryState = {
    ui: {
        historyGrid: {
            loading: false,
            pagination: {
                pageSize: 20,
                skip: 0
            },
            total: null,
            filter: []
        }
    },
    data: {
        history: {
            idMap: {},
            idSort: []
        },
        users: {
            idMap: {},
            idSort: []
        }
    }
};

export interface HistoryState {
    ui: {
        historyGrid: {
            loading: boolean;
            pagination: HistoryPagination;
            total: number;
            filter: FilterModel[];
        };
    };
    data: {
        history: EntityState<number, History>;
        users: EntityState<number, User>;
    };
}

export interface HistoryPagination {
    pageSize: number;
    skip: number;
}
